module.exports = __webpack_public_path__ + "img/prohibit.1409ee5.svg";